import { Component, Input, OnInit } from '@angular/core';
import { EvaluationService } from '../../../../_services';
import { DownloadWithToastsService } from '../../../_shared/download-with-toasts';
import { DecimalPipe } from '@angular/common';

@Component({
    selector: 'session-detail-evaluations',
    templateUrl: 'evaluations.component.html',
    styleUrls: ['evaluations.component.scss'],
    providers: [DecimalPipe],
})
export class SessionDetailEvaluationsComponent implements OnInit {
    @Input() sessionId;
    evaluations: any = [];
    evaluationsAvg: any;
    evaluationsPer: any;
    loadingEvaluations = false;

    constructor(
        private evaluationService: EvaluationService,
        private downloadService: DownloadWithToastsService
    ) {}

    async downloadEvaluations(
        sessionId: number,
        document: string,
        type: string,
        fileName: string
    ) {
        await this.downloadDocument(
            `/api/training-sessions/${sessionId}/documents.pdf/?docs=${document}&template=ZENIKA`,
            type,
            fileName
        );
    }

    async downloadDocument(route: string, type: string, fileName: string) {
        await this.downloadService.downloadAndOpenDocument(
            route,
            type,
            fileName
        );
    }

    getpropAverage(arr: any[], prop: string): number {
        return arr
            .filter((obj) => obj[prop])
            .reduce(
                (acc, obj) => {
                    acc.count++;
                    acc.total += obj[prop];
                    return acc;
                },
                {
                    total: 0,
                    count: 0,
                    average: function () {
                        return this.total / this.count;
                    },
                }
            )
            .average();
    }

    getAverages(arr): void {
        Object.keys(this.evaluationsAvg).forEach((prop) => {
            let avg = this.getpropAverage(arr, prop);
            this.evaluationsAvg[prop] = !isNaN(avg)
                ? Math.round(avg * 100) / 100
                : '-';
        });
    }

    getpropPercentage(arr: any[], prop: string): number {
        return arr
            .reduce(
                (acc, obj) => {
                    acc.count++;
                    acc.total += obj[prop] ? 1 : 0;
                    return acc;
                },
                {
                    total: 0,
                    count: 0,
                    average: function () {
                        return (this.total * 100) / this.count;
                    },
                }
            )
            .average();
    }

    getPercentages(arr): void {
        Object.keys(this.evaluationsPer).forEach((prop) => {
            let percentage = this.getpropPercentage(arr, prop);
            this.evaluationsPer[prop] = !isNaN(percentage)
                ? Math.round(percentage * 100) / 100
                : '-';
        });
    }

    ngOnInit(): void {
        this.evaluationsAvg = {
            trainerAnswerQuality: 0,
            trainerAvailability: 0,
            trainerPedagogicalQuality: 0,
            trainerSubjectKnowledge: 0,
            trainingContentRichness: 0,
            trainingExamples: 0,
            trainingLayout: 0,
            trainingPracticeInterest: 0,
            trainingTheoryPracticeRatio: 0,
        };

        this.evaluationsPer = {
            levelAdapted: 0,
            satisfied: 0,
        };

        this.loadEvaluations();
    }

    loadEvaluations(): void {
        this.loadingEvaluations = true;
        this.evaluationService
            .findBySessionId(this.sessionId)
            .subscribe((results) => {
                this.evaluations = results;
                this.loadingEvaluations = false;
                this.getAverages(results);
                this.getPercentages(results);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/session/detail/evaluations/evaluations.component.ts